require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./authors-part-time-marketing-customer-services-manager.json") })
        }
      }, "path---authors-part-time-marketing-customer-services-manager");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---authors-part-time-marketing-customer-services-manager!./.cache/json/authors-part-time-marketing-customer-services-manager.json
// module id = 1322
// module chunks = 231608221292675